let config = {
  emailjs: {
    serviceID: "service_ez9cjpd",
    templateID: "template_ze9wvrm",
    userID: "epx2oyqbOm3_tSBg4"
  },
  recaptcha: {
    key: "6LcWX28pAAAAAA9yCd37t6NZb168INQS8445LUeA"
  }
};

export default config;
